import { render, staticRenderFns } from "./viewNOTIC.vue?vue&type=template&id=58fdf858&scoped=true"
import script from "./viewNOTIC.vue?vue&type=script&lang=js"
export * from "./viewNOTIC.vue?vue&type=script&lang=js"
import style0 from "./viewNOTIC.vue?vue&type=style&index=0&id=58fdf858&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58fdf858",
  null
  
)

export default component.exports